<template>
  <div
    v-if="response?.data?.paymentIcons?.[0]"
    class="payment-icons payment-shipping__icons"
  >
    <div
      v-if="response?.data?.paymentIcons[0]?.Title"
      class="payment-icons__title payment-shipping__icons-title"
    >
      {{ response?.data?.paymentIcons[0].Title }}
    </div>

    <ul class="payment-icons__list payment-shipping__icons-content">
      <li
        v-for="group in response?.data.paymentIcons[0].Icons"
        :key="group"
      >
        <component
          :is="getElement(group.Link)"
          class="payment-icons__link payment-shipping__icons-link"
          :class="`${group.Icon}`"
          :to="group.Link"
        >
          <component
            :is="loadIcon(group.Icon)"
            v-if="group.Icon"
            filled
            class="icon"
            :class="`icon--${useDash(group.Icon)}`"
          />
          <span class="visually-hidden">{{ group.Name }}</span>
        </component>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
// import layoutQuery from '~layers/app/graphql/layout.gql'

import {
  AppLink,
} from '#components'

const { public: config } = useRuntimeConfig()
// const { data } = await useAsyncQuery(layoutQuery, { locale: config.strapiLocale })

const { data: response } = await useAsyncGraphqlQuery('layout', {
  locale: config.strapiLocale,
}, useGraphqlDefaultClient())

function getElement(to: any) {
  return to ? AppLink : 'span'
}

const { loadIcon } = useStrapiIcons()
</script>

<!-- <style src="~layers/app/components/App/PaymentIcons.css" /> -->
<style>
@import url("~layers/app/components/App/PaymentIcons.css");
</style>
